import { tokenIssuedAt } from '@dia/db';

/**
 * Two doors lead into the ops app and a browser can hold a session from each:
 * a staff session (a device token and a PIN) and an owner session (Supabase
 * Auth, email and password). Nothing ever cleared the one when the other was
 * used, so a crew session left in the browser by an earlier test outranked the
 * owner who had just signed in, and the owner saw a crew home screen and
 * "this part is only for managers" on the phones screen.
 *
 * One person is using the screen right now, so exactly one identity applies:
 * the session that was opened most recently. That is what they just did. When
 * the age cannot be told (a token with no issue time) the owner door wins,
 * because it is the deliberate one: nobody types an email and a password by
 * accident.
 */
export function pickIdentity(
  staffToken: string | null | undefined,
  ownerToken: string | null | undefined,
): 'staff' | 'owner' | null {
  if (staffToken && !ownerToken) return 'staff';
  if (ownerToken && !staffToken) return 'owner';
  if (!staffToken || !ownerToken) return null;

  const staffAt = tokenIssuedAt(staffToken);
  const ownerAt = tokenIssuedAt(ownerToken);
  if (staffAt !== null && ownerAt !== null && staffAt > ownerAt) return 'staff';
  return 'owner';
}
